var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component"},[_c('div',{staticClass:"box"},[(_vm.hasMsg)?_c('div',{ref:"message",staticClass:"message"},[(this.messageList.length>0)?_c('svg-icon',{attrs:{"iconName":"message","iconSize":"32"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.message)+" ")],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }